import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { i18n } from '../../../translate/i18n';
import * as actions from "../../../store/actions";
import { isEmpty, uniqueId, orderBy as orderByLoadash } from 'lodash';
import {
  Typography, FormControl, TextField, FormControlLabel,  Button,  Divider, FormLabel, RadioGroup, Radio,
} from '@mui/material';
import filesize from "filesize";
import { map as asyncMap } from 'p-iteration';
import ListIcon from '@mui/icons-material/List';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import axios from 'axios';

import resizeFile from '../../../utils/imageResizer';
import API from '../../../axios/api';
import Modal from '../Modals/ModalAction';
import ActionExpansionPanel from '../../../UI/ActionExpansionPanel/ActionExpansionPanel';
import { createThreeQuestion } from '../../../utils/createThreeQuestion';
import Upload from '../../../UI/Upload';
import FileList from '../../../UI/FileList';
import confirm from '../../../UI/Confirm/confirm';
import { orderQuestionArray } from '../../../utils/orderQuestionArray';
import ServiceOldActionsPanel from '../../../components/ServiceOldActionsPanel/ServiceOldActionsPanel';

const FormServicesQuestionList = (props) => {
  const dispatch = useDispatch();

  // modal params
  const [openDialog, setOpenDialog] = useState(false);
  const [questionAction, setQuestionAction] = useState({});
  const [actionId, setActionId] = useState('');
  const [questionsThree, setQuestionsThree] = useState({})
  const [editModalData, setEditModalData] =  useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadSubmitError, setUploadSubmitError] = useState(false);
  const [filesIdWithError, setFilesIdWithError] = useState([]);

  const questionsServiceForm = useSelector(state => state.serviceForm.questions);
  const oldActions = useSelector(state => state.serviceForm.oldActions);

  useEffect(() => {
    setQuestionsThree(createThreeQuestion(questionsServiceForm, props.isNewData ? 'groupPopulated' : 'groupAsName'))
  }, [questionsServiceForm])

  const handleChangeRadio = (event, question) => {
    dispatch(actions.answerQuestionServiceForm(event.target.value, question))
    props.handleCountAnsweredQuestions();
    if (props.mandatoryActionsForNotComplyQuestions && event.target.value === 'NO') {
      setQuestionAction(question);
      setActionId('new');
      setOpenDialog(true);
    }
  }

  const handleChangeComment = (event, question) => {
    dispatch(actions.commentQuestionServiceForm(event.target.value, question))
  }

  const handleClickAddAction = (e, question) => {
    e.stopPropagation();

    setQuestionAction(question)
    setActionId('new');
    setOpenDialog(true);
  }

  const handleClickEditAction = action => {
     // check if the action is aready in the backend, has a mongo _id
    if(action._id.length === 24) {
        props.history.push(`/form-action/${action._id}`)
    } else {
        setEditModalData(action)
        setActionId(action._id);
        setOpenDialog(true);
    }

  }

  const handleUpload = async (files, questionId) => {
    const uploadingFiles = await asyncMap(files, async (file) => {
      const fileOptimized = await resizeFile(file)

      return ({
        file: fileOptimized,
        id: uniqueId(),
        name: fileOptimized.name,
        readableSize: filesize(fileOptimized.size),
        preview: URL.createObjectURL(fileOptimized),
        fileType: fileOptimized.type,
        progress: 0,
        isNotUploaded: true,
        error: false,
        url: null
      });
    });

    dispatch(actions.addFileQuestionServiceForm(uploadingFiles, questionId));
    uploadingFiles.forEach((file) => processUpload(file, questionId));
  };

  const updateFile = (fileId, file, questionId) => {
    dispatch(actions.editFileQuestionServiceForm(fileId, file, questionId));
  };

  const retryUpload = async (file, questionId) => {
    updateFile(file, {error: false}, questionId)
    await processUpload(file, questionId);
  }

  const processUpload = async (uploadedFile, questionId) => {
    props.setUploadSubmitError(false);
    props.setFileUploadError(false);

    API.post("files/signurl", { file: uploadedFile }).then(signUrlRes => {

      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          }, questionId);
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              error: false,
              loading: false,
            }, questionId);
          }).catch((e) => {
            updateFile(uploadedFile.id, {
              error: true,
              loading: false,
            }, questionId);
            console.log(e.message)
          })
      }).catch((e) => {
        updateFile(uploadedFile.id, {
          error: true,
          loading: false,
        }, questionId);
        console.log(e.message)
      })  
    }).catch((e) => {
      updateFile(uploadedFile.id, {
        error: true,
        loading: false,
      }, questionId);
      console.log(e.message)
    });
  }

  const handleDeleteQuestionFile = (fileId, questionId) => {
    if (!props.editMode && !props.isNewData) return;
    confirm(i18n.t('handleDeleteDocumentFileFormService.confirm'),
      {
        title: i18n.t('handleDeleteDocumentFileFormService.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          handleDelete(fileId, questionId)
        },
      )
  }

  const handleDelete = async (fileId, questionId) => {
    try {
      props.setUploadSubmitError(false);
      props.setFileUploadError(false);
      if (fileId.length === 24) await API.delete(`files/${fileId}`)
      dispatch(actions.deleteFileQuestionServiceForm(fileId, questionId));
    } catch (e) {
      console.log('e', e);
    }
  }

  const closeModal = () => {
    setOpenDialog(false);
  }

  let checklistScore = 0;

  if(!isEmpty(questionsThree)) {
    let score = 0;
    let totalScore = 0;

    questionsThree.forEach(group => {
      if (group.totalScore) {
        score += group.score;
        totalScore += group.totalScore;
      }
    })

    if (totalScore > 0) checklistScore = ((score/totalScore) * 100).toFixed(2);
  }

  let numberOfQuestionsThatShouldHaveActions = 0;

  return <>
    <Modal
      open={openDialog}
      question={questionAction}
      actionId={actionId}
      editModalData={editModalData}
      actionShouldPost={props.actionShouldPost}
      onClose={closeModal}
    />
      <div style={styles.itensVerifContainer}>
          {<div style={styles.sectionTitleContainer}>
              <ListIcon style={{ color: (!props.isNewData && !props.editMode) ? 'lightgrey' : '#000' }} />
              <Typography style={{ ...styles.itensVerifLabel, color: (!props.isNewData && !props.editMode) ? 'lightgrey' : '#000' }}>
                  {i18n.t('typographyFormServiceQuesList.itensVerifLabel')}
              </Typography>
              {!isEmpty(questionsThree) &&
                <div style={styles.score}>
                  <div style={styles.scoreText}>
                    {`${checklistScore}%`}
                  </div>
                  <PlaylistAddCheckCircleIcon />
                </div>
              }
          </div>}
          {!isEmpty(questionsThree) && questionsThree.map(group =>
              <div key={group._id}>
                  <div style={styles.groupName}>
                    {group.name}
                    {group.totalScore > 0 &&
                      <div style={styles.score}>
                        <div style={styles.scoreText}>
                          {`${(group.score/group.totalScore * 100).toFixed(2)}%`}
                        </div>
                        <PlaylistAddCheckCircleIcon />
                      </div>
                    }
                  </div>
                  {group.questionArray.sort(orderQuestionArray).map((question, index) => {
                    const oldActionsForThisQuestion = oldActions.filter((action) => {
                      if (question.actions?.some((newAction) => newAction._id === action._id)) return false;
                      const questionId = question.id || question.questionsId;
                      return questionId === action.question;
                    });
                    const questionRef = React.createRef();
                    const questionShouldHaveActions = (
                      props.mandatoryActionsForNotComplyQuestions
                      && question.answer === 'NO'
                      && question.actions.length === 0
                      && oldActionsForThisQuestion.length === 0
                    );
                    if (question.answer === '') props.questionsRefs.push(questionRef);
                    else if (questionShouldHaveActions) {
                      props.questionsRefs.push(questionRef);
                      numberOfQuestionsThatShouldHaveActions += 1;
                    }

                    if (index === (group.questionArray.length - 1)) props.setNumberOfQuestionsThatShouldHaveActions(numberOfQuestionsThatShouldHaveActions);

                    return (
                      <div key={question._id} ref={questionRef}>
                        <FormControl variant="standard" style={styles.formControl}>
                            <FormLabel
                                style={{ color: (!props.isNewData && !props.editMode) ? 'lightgrey' : '#000', fontSize: '0.9rem', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}
                                component="legend">
                                <>
                                {question.name}
                                <Button variant="outlined" disabled={(!props.isNewData && !props.editMode)} size="small" onClick={(e) => handleClickAddAction(e, question)} style={styles.buttonAction}>
                                    {i18n.t('buttonFormservQuesList.text')}
                                </Button>
                                </>
                            </FormLabel>
                            <RadioGroup aria-label="gender" name={question._id} value={question.answer} onChange={(e) => handleChangeRadio(e, question)} style={{flexDirection: 'row'}}>
                                <FormControlLabel value="YES" control={<Radio disabled={!props.isNewData && !props.editMode} />} style={{fontSize: '0.8rem'}} label={i18n.t('formControlLabelFormServiceQuestList.YES')} />
                                <FormControlLabel value="NO" control={<Radio disabled={!props.isNewData && !props.editMode} />} style={{fontSize: '0.8rem'}} label={i18n.t('formControlLabelFormServiceQuestList.NO')} />
                                <FormControlLabel value="NA" control={<Radio disabled={!props.isNewData && !props.editMode} />} style={{fontSize: '0.8rem'}} label={i18n.t('formControlLabelFormServiceQuestList.NA')} />
                            </RadioGroup>
                            {questionShouldHaveActions && <Typography sx={{color: 'red', fontSize: '12px'}}>{i18n.t('formControlLabelFormServiceQuestList.needAction')}</Typography>}
                            { (question.commentFlag) &&
                              <FormControl variant="standard" fullWidth>
                                <TextField
                                  multiline
                                  rows={3}
                                  label={i18n.t('textFieldFormServiceQuesList.comment')}
                                  variant='outlined'
                                  name='comment'
                                  onChange={ (event) => handleChangeComment(event, question) }
                                  value={question.comment}
                                  margin='normal'
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  disabled={ (!props.editMode && !props.isNewData) }
                                />
                            </FormControl>
                            }
                            {
                              (question.fileFlag) && <>
                                <Upload onUpload={(files) => handleUpload(files, question._id)} disabled={!props.editMode && !props.isNewData} />
                                {question.files?.length > 0 && (
                                  <FileList
                                    files={question.files}
                                    onDelete={(fileId) => handleDeleteQuestionFile(fileId, question._id)}
                                    disabled={!props.editMode && !props.isNewData}
                                    retry={(file) => retryUpload(file, question._id)}
                                  />
                                )}
                                {uploadSubmitError && <div style={styles.fileError}>{i18n.t('divFormService.fileError')}</div>}
                              </>
                            }
                        </FormControl>
                        {question.actions && question.actions.length > 0 &&
                            <ActionExpansionPanel
                              data={question.actions}
                              disabled={!props.isNewData && !props.editMode}
                              onAdd={(e) => handleClickAddAction(e, question)}
                              onEdit={handleClickEditAction}
                            />
                        }
                        {(oldActionsForThisQuestion.length > 0) &&
                          <ServiceOldActionsPanel
                            actions={oldActionsForThisQuestion}
                            title={i18n.t('serviceOldActionsPanel.title')}
                          />
                        }
                      </div>
                    );
                  })}
                  <Divider style={{ marginTop: 10 }} />
              </div>
          )}
      </div>
  </>;
}

export default withRouter(FormServicesQuestionList);

const styles = {
  itensVerifContainer: {
    marginBottom: 10,
  },
  itensVerifLabel: {
    paddingLeft: 10,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
    position: 'relative'
  },
  formControl: {
    display: 'flex',
    marginTop: 10,
    marginLeft: 10,
    paddingLeft: 5,
    paddingRight: 5,
  },
  groupName: {
      fontSize: '0.8rem',
      marginTop: '10px',
      backgroundColor: '#e4e4e4',
      textAlign: 'center',
      paddingTop: 4,
      paddingBottom: 4,
      position: 'relative'
  },
  score: {
    position: 'absolute',
    paddingTop: 4,
    paddingRight: 8,
    top: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  scoreText: {
    fontWeight: 'bold',
    marginRight: 8
  },
  fileError: {
    color: '#f44336'
  },
  buttonAction: {
    width: "10rem",
    minWidth: "10rem"
  }
}
